import { render, staticRenderFns } from "./SplitItemModal.vue?vue&type=template&id=6643aefb&scoped=true"
import script from "./SplitItemModal.vue?vue&type=script&lang=js"
export * from "./SplitItemModal.vue?vue&type=script&lang=js"
import style0 from "./SplitItemModal.vue?vue&type=style&index=0&id=6643aefb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643aefb",
  null
  
)

export default component.exports